<!-- eslint-disable -->
<template lang="pug">
    .olympiad-stage
        .olympiad-stage__header-block
            .olympiad-stage-header
                .olympiad-stage-header__grid-col
                    .olympiad-stage-header__title
                        | {{ $i18n.t('olympiads.olympiads_stageForm_stage') }} &nbsp;
                        span(v-text="stageIndex + 1")
                .olympiad-stage-header__grid-col.olympiad-stage-header__grid-col--narrow
                    cs-button.olympiad-stage-header__circle-button(
                        pattern="primary-outline",
                        @click="$emit('upStage', stageIndex)"
                    )
                        svg-icon(name="angle-up", middle)
                    cs-button.olympiad-stage-header__circle-button(
                        pattern="primary-outline",
                        @click="$emit('downStage', stageIndex)"
                    )
                        svg-icon(name="angle-down", middle)
                    cs-button.olympiad-stage-header__circle-button(
                        pattern="primary-outline",
                        @click="$emit('removeStage', stageIndex)"
                    )
                        svg-icon(name="times", middle)
            .olympiad-stage__grid(v-for="index in gamesLength")
                .olympiad-stage__block
                    .olympiad-stage__label
                        | {{ index === 1 ? $i18n.t('homework.homework_create_chooseGames') : ' ' }}
                    .olympiad-stage__block-body
                        cs-multiselect(
                            :multiple="false",
                            :options="games",
                            :show-labels="false",
                            :allow-empty="false",
                            :placeholder="games.length === 0 ? '' : $i18n.t('course.course_form_chooseGamesPlaceholder')",
                            :disabled="games.length === 0",
                            label="name",
                            :value="stage.games[index - 1]",
                            @select="gameHandler($event, index - 1)"
                        )
        .olympiad-stage__game-preview(v-for="(game, index) in stage.games")
            .olympiad-game-header
                .olympiad-game-header__grid-col
                    .olympiad-game-header__title
                        img.olympiad-game-header__image(:src="`/imgs/game-icons/${game.slug}.png`")
                        .olympiad-game-header__title-text
                            p.olympiad-game-header__subtitle
                                | {{ $i18n.t('olympiads.olympiads_stageForm_game') }}
                                |
                                | {{ index + 1 }}
                            span.olympiad-game-header__name(v-text="getGameName(game)")
                .olympiad-game-header__grid-buttons-col
                    cs-button.olympiad-stage-header__circle-button(
                        pattern="primary-outline",
                        @click="upGame(index)"
                    )
                        svg-icon(name="angle-up", middle)
                    cs-button.olympiad-stage-header__circle-button(
                        pattern="primary-outline",
                        @click="downGame(index)"
                    )
                        svg-icon(name="angle-down", middle)
                    cs-button.olympiad-stage-header__circle-button(
                        pattern="primary-outline",
                        @click="stage.games.splice(index, 1)"
                    )
                        svg-icon(name="times", middle)
            .olympiad-game-settings
                .olympiad-game-settings__button-container
                    cs-button.olympiad-game-settings__button(pattern="primary-outline", color="blue", @click="editGame(index)" narrow)
                        svg-icon.olympiad-game-settings__button-item(name="cog")
                        =" "
                        span.olympiad-game-settings__button-item {{ $i18n.t('olympiads.olympiads_stageForm_tune') }}
                    span.help.is-danger(v-show="errors.has('game_' + index)" v-text="errors.first('game_' + index)")
                .olympiad-game-settings__parameters
                    div(v-if="game.parameters.default", :is="getPreview(game.slug)", :game="game", :with-icon="false")
                    template(v-else)
                        .row
                            .col-sm-6
                                svg-icon(name="exclamation-circle")
                            .col-sm-6 {{ $i18n.t('olympiads.olympiads_stageForm_configureTheParameters') }}
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../utils/trainer/trainer';
    import { getInitParameters } from '../../utils/trainer/getInitParameters';
    const AddSubPreview = () => import('../games/games-previews/AddSubPreview.vue');
    const FlashCardsPreview = () => import('../games/games-previews/FlashCardsPreview.vue');
    const MultDivPreview = () => import('../games/games-previews/MultDivPreview.vue');
    const EquationPreview = () => import('../games/games-previews/EquationPreview.vue');
    const AnzanPreview = () => import('../games/games-previews/AnzanPreview.vue');
    const PuzzlePreview = () => import('../games/games-previews/PuzzlePreview.vue');
    const CouplesPreview = () => import('../games/games-previews/CouplesPreview.vue');
    const ChainsPreview = () => import('../games/games-previews/ChainsPreview.vue');
    const ScannerPreview = () => import('../games/games-previews/ScannerPreview.vue');
    const WordsFieldPreview = () => import('../games/games-previews/WordsFieldPreview.vue');
    const AnagramsPreview = () => import('../games/games-previews/AnagramsPreview.vue');
    const TextsPreview = () => import('../games/games-previews/TextsPreview.vue');
    const LettersFieldPreview = () => import('../games/games-previews/LettersFieldPreview.vue');
    const CatchWordPreview = () => import('../games/games-previews/CatchWordPreview.vue');
    const VisionFieldPreview = () => import('../games/games-previews/VisionFieldPreview.vue');
    const SchultePreview = () => import('../games/games-previews/SchultePreview.vue');
    const MatrixPreview = () => import('../games/games-previews/MatrixPreview.vue');
    const NavigatorPreview = () => import('../games/games-previews/NavigatorPreview.vue');
    const SynonymsPreview = () => import('../games/games-previews/SynonymsPreview.vue');
    const DivideItRightPreview = () => import('../games/games-previews/DivideItRightPreview.vue');
    const ChooseItRightPreview = () => import('../games/games-previews/ChooseItRightPreview.vue');
    const DivideUnstressedVowelsPreview = () => import('../games/games-previews/DivideUnstressedVowelsPreview.vue');
    const WordStructurePreview = () => import('../games/games-previews/WordStructurePreview.vue');
    const SentenceParsingPreview = () => import('../games/games-previews/SentenceParsingPreview.vue');
    const VocabularyWordsRusPreview = () => import('../games/games-previews/VocabularyWordsRusPreview.vue');
    const LettersSoundsSyllablesPreview = () => import('../games/games-previews/LettersSoundsSyllablesPreview.vue');
    const TransferSyllablesPreview = () => import('../games/games-previews/TransferSyllablesPreview.vue');
    const HardSoftConsonantsPreview = () => import('../games/games-previews/HardSoftConsonantsPreview.vue');
    const TranscriptionInWordPreview = () => import('../games/games-previews/TranscriptionInWordPreview.vue');
    const VoicedAndDeafConsonantsPreview = () => import('../games/games-previews/VoicedAndDeafConsonantsPreview.vue');
    const PartsOfSpeechPreview = () => import('../games/games-previews/PartsOfSpeechPreview.vue');
    const ParsingSentencePartsSpeechPreview = () => import('../games/games-previews/ParsingSentencePartsSpeechPreview.vue');
    const SortOneManyPreview = () => import('../games/games-previews/SortOneManyPreview.vue');
    const GenericWordsPreview = () => import('../games/games-previews/GenericWordsPreview.vue');
    const VerbTensesPreview = () => import('../games/games-previews/VerbTensesPreview.vue');
    const PunctuationMarksPreview = () => import('../games/games-previews/PunctuationMarksPreview.vue');
    const AlphabetPreview = () => import('../games/games-previews/AlphabetPreview.vue');
    const ConnectThePuzzlesPreview = () => import('../games/games-previews/ConnectThePuzzlesPreview.vue');
    const OrthographPreview = () => import('../games/games-previews/OrthographPreview.vue');

    import { mapState } from 'vuex';
    import _ from 'lodash';

    export default {
        props: {
            games: Array,
            stage: Object,
            stageIndex: Number,
        },
        mixins: [TrainerUtilities],
        computed: {
            ...mapState({
                battle: state => state.battle.battle,
            }),
            gamesLength() {
                return this.stage.games.length + 1;
            },
        },
        methods: {
            gameHandler(game, index) {
                this.$set(this.stage.games, index, _.cloneDeep(game));
                this.stage.games[index].parameters.default = getInitParameters(this.stage.games[index]);
            },
            getPreview(game) {
                switch (game) {
                    case 'MultiplicationAndDivision':
                        return 'mult-div-preview';
                    case 'FlashCards':
                    case 'InteractiveFlashCards':
                        return 'flash-cards-preview';
                    case 'AdditionAndSubtraction':
                    case 'AdditionAndSubtractionWithTime':
                        return 'add-sub-preview';
                    case 'Equation':
                        return 'equation-preview';
                    case 'Anzan':
                        return 'anzan-preview';
                    case 'Puzzle':
                        return 'puzzle-preview';
                    case 'Chains':
                        return 'chains-preview';
                    case 'Couples':
                        return 'couples-preview';
                    case 'Schulte':
                        return 'schulte-preview';
                    case 'Scanner':
                        return 'scanner-preview';
                    case 'Anagrams':
                        return 'anagrams-preview';
                    case 'WordsField':
                        return 'words-field-preview';
                    case 'Texts':
                        return 'texts-preview';
                    case 'LettersField':
                        return 'letters-field-preview';
                    case 'CatchWord':
                        return 'catch-word-preview';
                    case 'Matrix':
                        return 'matrix-preview';
                    case 'Navigator':
                        return 'Navigator-preview';
                    case 'Synonyms':
                        return 'synonyms-preview';
                    case 'VisionField':
                        return 'vision-field-preview';
                    case 'DivideItRight':
                        return 'divide-it-right-preview';
                    case 'ChooseItRight':
                        return 'choose-it-right-preview';
                    case 'DivideUnstressedVowels':
                        return 'divide-unstressed-vowels-preview';
                    case 'VocabularyWordsRus':
                        return 'vocabulary-words-rus-preview';
                    case 'LettersSoundsSyllables':
                        return 'letters-sounds-syllables-preview';
                    case 'TransferSyllables':
                        return 'transfer-syllables-preview';
                    case 'HardSoftConsonants':
                        return 'hard-soft-consonants-preview';
                    case 'TranscriptionInWord':
                        return 'transcription-in-word-preview';
                    case 'VoicedAndDeafConsonants':
                        return 'voiced-and-deaf-consonants-preview';
                    case 'PartsOfSpeech':
                        return 'parts-of-speech-preview';
                    case 'ParsingSentencePartsSpeech':
                        return 'parsing-sentence-parts-speech-preview';
                    case 'GenericWords':
                        return 'generic-words-preview';
                    case 'WordStructure':
                        return 'word-structure-preview';
                    case 'SentenceParsing':
                        return 'sentence-parsing-preview';
                    case 'VerbTenses':
                        return 'verb-tenses-preview';
                    case 'SortOneMany':
                        return 'sort-one-many-preview';
                    case 'PunctuationMarks':
                        return 'punctuation-marks-preview';
                    case 'Alphabet':
                        return 'alphabet-preview';
                    case 'Orthograph':
                        return 'orthograph-preview';
                }
            },
            upGame(index) {
                if (index !== 0) {
                    this.stage.games.splice(index - 1, 0, this.stage.games.splice(index, 1)[0]);
                }
            },
            downGame(index) {
                if (index !== this.stage.games.length - 1) {
                    this.stage.games.splice(index + 1, 0, this.stage.games.splice(index, 1)[0]);
                }
            },
            editGame(index) {
                let gamesParameters = {};
                let game = _.find(this.games, { slug: this.stage.games[index].slug });
                let slug = game.slug;
                gamesParameters[slug] = game.parameters.default;
                this.$store.dispatch('setGamesParameters', _.cloneDeep(gamesParameters));
                let routeParams = {
                    battleId: this.$route.params.battleId,
                    index: this.$route.params.index,
                    stageId: this.stageIndex,
                    id: index,
                };
                this.$router.push({ name: 'stage-game:edit', params: routeParams });
            },
        },
        components: {
            AddSubPreview,
            FlashCardsPreview,
            MultDivPreview,
            EquationPreview,
            AnzanPreview,
            PuzzlePreview,
            ChainsPreview,
            CouplesPreview,
            SchultePreview,
            ScannerPreview,
            WordsFieldPreview,
            AnagramsPreview,
            TextsPreview,
            LettersFieldPreview,
            CatchWordPreview,
            MatrixPreview,
            NavigatorPreview,
            SynonymsPreview,
            VisionFieldPreview,
            DivideItRightPreview,
            ChooseItRightPreview,
            DivideUnstressedVowelsPreview,
            WordStructurePreview,
            SentenceParsingPreview,
            VocabularyWordsRusPreview,
            LettersSoundsSyllablesPreview,
            TransferSyllablesPreview,
            HardSoftConsonantsPreview,
            TranscriptionInWordPreview,
            VoicedAndDeafConsonantsPreview,
            PartsOfSpeechPreview,
            ParsingSentencePartsSpeechPreview,
            SortOneManyPreview,
            GenericWordsPreview,
            VerbTensesPreview,
            PunctuationMarksPreview,
            AlphabetPreview,
            ConnectThePuzzlesPreview,
            OrthographPreview,
        },
    };
</script>

<style lang="scss" scoped>
    .olympiad-stage {
        width: 100%;
    }

    .olympiad-stage__divider {
        border: 0;
        background: $hsl-color-gray-74;
        height: 1px;
        width: 100%;
        margin: 30px auto;
    }

    .olympiad-stage-header,
    .olympiad-game-header {
        @include make-grid;
        @include stack-space($space-small);
        @include inset-space($space-xx-small);
        align-items: center;
        justify-content: space-between;
    }
    .olympiad-game-header {
        margin: 0;
        flex-direction: column;
        align-items: flex-start;
        @include media($md) {
            flex-direction: row;
            margin-bottom: 15px;
        }
    }

    .olympiad-stage-header__title {
        white-space: nowrap;
        font-weight: 500;
        font-size: 18px;
        @include stack-space($space-base);
        padding-right: 10%;
        margin-top: 5px;
    }

    .olympiad-stage-header__grid-col,
    .olympiad-game-header__grid-col {
        @media screen and (min-width: 768px) and (max-width: 992px) {
            width: 50%;
        }
    }

    .olympiad-stage-header__grid-col--narrow,
    .olympiad-game-header__grid-col--header {
        text-align: right;
    }

    .olympiad-stage-header__circle-button {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        margin: $space-xx-small;
        border-radius: 50%;
        width: 2em;
        height: 2em;
        padding: 0 !important;
    }

    .olympiad-stage__header-block {
        @include inset-space($space-small);
        @include stack-space($space-base);
    }

    .olympiad-stage__grid {
        @include make-grid;
        @include media($lg) {
            margin-left: auto;
            width: 80%;
        }
        @include media($xl) {
            width: 70%;
        }
    }

    .olympiad-stage__block {
        margin-bottom: 20px;
        @include make-col;
        padding-right: 0;
        display: flex;
        @media screen and (max-width: 767px) {
            padding-left: 0;
            flex-wrap: wrap;
            margin-bottom: 0;
            max-width: 100%;
            :first-child {
                @include stack-space($space-base);
            }
        }
    }

    .olympiad-stage__label {
        min-width: 8em;
        font-size: 16px;
        line-height: 19px;
        text-align: left;
        margin-right: 10px;
        align-self: center;
    }

    .olympiad-stage__block-body {
        flex-grow: 5;
        @media screen and (max-width: 767px) {
            width: 100%;
        }
    }

    .olympiad-stage__game-preview {
        @include inset-space($space-base);
        margin-bottom: 8px;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
    }

    .olympiad-game-header__title {
        display: flex;
        flex-wrap: wrap;
    }

    .olympiad-game-header__image {
        vertical-align: middle;
        min-height: 30px;
        margin: 0 10px 10px 0;
        @include media($sm) {
            @include inline-space($space-small);
        }
        @include media($lg) {
            min-height: 45px;
        }
    }

    .olympiad-game-header__title-text {
        vertical-align: middle;
        display: inline-block;
    }

    .olympiad-game-header__subtitle {
        @include stack-space($space-xx-small);
        line-height: 18px;
        font-weight: 500;
        @include media($xlg) {
            line-height: 20px;
        }
    }

    .olympiad-game-header__name {
        font-size: $font-size-14;
        @include media($sm) {
            font-size: $font-size-16;
        }
        @include media($lg) {
            font-size: $font-size-18;
        }
    }

    .olympiad-game-header__grid-buttons-col {
        text-align: left;
        margin: 10px 0;
        @include media($sm) {
            text-align: right;
        }
        @include media($md) {
            margin: 10px 0 0 10px;
        }
    }
    .olympiad-game-settings {
        @include make-grid($space-small);
        @include stack-space($space-small);
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
        }
    }

    .olympiad-game-settings__button-container {
        @include inset-space($space-x-small);
        margin: 0 auto 0 0;
        @include media($md) {
            margin: 0 15px 0 0;
        }
    }

    .olympiad-game-settings__parameters {
        @include inset-space($space-x-small);
        @include media($md) {
            width: 50%;
        }
    }

    .olympiad-game-settings__button {
        padding: 10px 30px !important;
        font-size: 16px !important;
        font-weight: 500 !important;
    }

    .olympiad-game-settings__button-item {
        vertical-align: middle;
        margin-right: 8px;
    }
</style>
